export default {
    items: { data: [] }
}